import React, { useEffect } from "react";
import './style.css'

const DeploymentPage = ({setActivePath}) => {
    useEffect(() => {
        setActivePath("Deployment");
      }, [setActivePath]);


  return (
    <div className="outlet-container">
       Deployment
      
    </div>
  )
}

export default DeploymentPage
